import { Box, Stack, Text, TextLink } from '@n26/nxd'
import styles from './Footer.module.css'

const LEGAL_LINKS = [
  { label: 'Privacy Policy', href: 'https://n26.com/en-eu/privacy-policy' },
  { label: 'Cookie Policy', href: 'https://n26.com/en-eu/cookie-policy' },
  { label: 'Legal Notice', href: 'https://n26.com/en-eu/legal-notice' },
] as const

export const Footer = () => (
  <footer role='contentinfo'>
    <Box
      as='nav'
      padding='24'
      backgroundColor='neutral'
      className={styles.nav}
    >
      <Stack
        direction={{ mobile: 'vertical', desktop: 'horizontal' }}
        space={{ mobile: '8', desktop: '16' }}
      >
        <Text>&copy;&nbsp;N26&nbsp;{new Date().getFullYear()}</Text>

        {LEGAL_LINKS.map(({ label, href }) => (
          <TextLink
            key={href}
            href={href}
            variant='subtle'
            target='_blank'
            rel='noreferrer'
          >
            {label}
          </TextLink>
        ))}
      </Stack>
    </Box>
  </footer>
)
